import { AssetSymbol } from "@/utils/types";

export const reserveUnderlyingAssets: Array<AssetSymbol> = [
  "DAI",
  "USDT",
  "USDC"
];

export const allAssets: Array<AssetSymbol> = ["DAI", "USDT", "USDC", "3CRV"];
